module.exports = __webpack_public_path__ + "static/media/login-bg.af053f08.png";